export default __webpack_public_path__ + "static/media/red_light_game.071eb4c4.jpg";